import _ from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useMount from '../../../../../../common/hooks/useMount';
import LoadingSpinner from '../../../../../../common/widgets/LoadingSpinner';
import { resources } from '../../../../resources/resources';
import { analyticsService } from '../../../../services/analytics';

export const ActiveProductsNumberCard = () => {
  const { t: translate } = useTranslation();
  const [activeProductsNumber, setActiveProductsNumber] = useState<
    number | undefined
  >();

  const loadActiveProductsNumber = async (
    abortController?: AbortController,
  ) => {
    const resp = await analyticsService.getActiveProductsNumber({
      signal: abortController?.signal,
    });
    if (abortController?.signal.aborted) return;
    if (!resp.hasErrors) {
      setActiveProductsNumber(resp.data);
    }
  };

  useMount(loadActiveProductsNumber);

  return (
    <div className="mydash-budget-card">
      <div className="mydash-budget-label">
        {translate(resources.analytics.activeProducts)}
      </div>
      <div className="mydash-budget-balance">
        {!_.isNil(activeProductsNumber) ? (
          activeProductsNumber
        ) : (
          <LoadingSpinner />
        )}
      </div>
    </div>
  );
};
